<script>
	import { getContext, onMount } from "svelte";

	const addTrigger = getContext("addTrigger");
	const duration = getContext("getDuration")();
	const easingGlobal = getContext("getEasing")();

	// position the element

	export let left = "";
	export let top = "";

	export let anchor = "center"; // "center", "top", "topright,

	$: translateAnchorX = anchor.indexOf("left") !== -1 ? "0" : anchor.indexOf("right") !== -1 ? "-100%" : "-50%";
	$: translateAnchorY = anchor.indexOf("top") !== -1 ? "0" : anchor.indexOf("bottom") !== -1 ? "-100%" : "-50%";

	// initial and final values

	export let animation = {};

	let easing = easingGlobal;
  if (animation.easing) easing = animation.easing;


  // handle delay and shorter duration

  let delayTransform = 0;
  let delayOpacity = 0;
  let durationTransform = duration;
  let durationOpacity = duration;

  if (animation.translateY && !animation.translateY[0]) {
    const tsy = Object.keys(animation.translateY).sort();
    const minty = tsy[0];
    delayTransform = minty * duration;
    animation.translateY[0] = animation.translateY[minty];
  }

  if (animation.translateX && !animation.translateX[0]) {
    const tsx = Object.keys(animation.translateX).sort();
    const mintx = tsx[0];
    delayTransform = mintx * duration;
    animation.translateX[0] = animation.translateX[mintx];
  }

  if (animation.opacity && !animation.opacity[0]) {
    const tso = Object.keys(animation.opacity).sort();
    const minto = tso[0];
    delayOpacity = minto * duration;
    animation.opacity[0] = animation.opacity[mintx];
  }

  if (animation.translateY && !animation.translateY[1]) {
    const tsyf = Object.keys(animation.translateY).sort().reverse();
    const mintyf = tsyf[0];

    durationTransform = mintyf * duration;
    animation.translateY[1] = animation.translateY[mintyf];
  }

  if (animation.translateX && !animation.translateX[1]) {
    const tsxf = Object.keys(animation.translateX).sort().reverse();
    const mintxf = tsxf[0];

    durationTransform = mintxf * duration;
    animation.translateX[1] = animation.translateX[mintxf];
  }


  if (animation.opacity && !animation.opacity[1]) {
    const tsof = Object.keys(animation.opacity).sort().reverse();
    const mintof = tsof[0];

    durationOpacity = mintof * duration;
    animation.opacity[1] = animation.opacity[mintof];
  }


  durationTransform -= delayTransform;
  durationOpacity -= delayOpacity;


  


	function getValues(x) {
		return [0, 1].map((e) => {
			if (typeof x[e] === "object") return x[e].value;
			return x[e];
		});
	}

	const translateX = animation.translateX ? getValues(animation.translateX) : [0, 0];
	const translateY = animation.translateY ? getValues(animation.translateY) : [0, 0];
	const opacity = animation.opacity ? getValues(animation.opacity) : [1, 1];

	let easingRealOpacity = easing;
	if (animation.opacity && animation.opacity[1].easing) easingRealOpacity = animation.opacity[1].easing;

	let easingRealTransform = easing;
	if (animation.translateY && animation.translateY[1].easing) easingRealTransform = animation.translateY[1].easing;
	if (animation.translateX && animation.translateX[1].easing) easingRealTransform = animation.translateX[1].easing;

	let state = 0;



	addTrigger((x) => {
    state = x;
  });


  const transition = `transform ${durationTransform / 1000}s ${delayTransform / 1000}s ${easingRealTransform}, opacity ${durationOpacity / 1000}s ${delayOpacity / 1000}s ${easingRealOpacity}`;
</script>

<div class="animatable-css" style:left style:top style:transform="translate({translateAnchorX}, {translateAnchorY})">
	<div
		class="animatable-css-inner"
		style:transform="translateX({translateX[state]}) translateY({translateY[state]})"
		style:opacity={opacity[state]}
    style:transition={transition}
	>
		<slot />
	</div>
</div>

<style lang="scss">
	.animatable-css {
		width: fit-content;
		height: fit-content;
		position: absolute;
  }
  .animatable-cc-inner {
    will-change: transform;
  }
</style>
